import { getAuthHeader } from '~/modules/common/utils/cookieUtils';

export default ({ res, $cookies }, inject) => {
  inject('cache', (value) => {
    if (process.server && !getAuthHeader($cookies)?.Authorization) {
      if (value.includes('public')) {
        value = value + ', stale-while-revalidate=14400, stale-if-error=86400';
      }
      return res.setHeader('Cache-Control', value);
    }
  });
};
